import React from 'react';

import SelectInput from '../../inputs/SelectInput';

import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';

import Timer from '@material-ui/icons/Timer';
import Close from '@material-ui/icons/Close';
import CloseIcon from '@material-ui/icons/Close';
import TickIcon from '@material-ui/icons/Check';
import PermIdentity from '@material-ui/icons/PermIdentity';
import Home from '@material-ui/icons/Home';
import Delete from '@material-ui/icons/Delete';

class Filter extends React.Component {
    state = {
        from: this.props.filter.from,
        to: this.props.filter.to,
        pending: this.props.filter.pending,
        saved: this.props.filter.saved,
        urgent: this.props.filter.urgent,
        selectedroles: this.props.filter.selectedroles,
        selectedlocals: this.props.filter.selectedlocals,
        selectedusers: this.props.filter.selectedusers,
        suggestions: [],
        locals: [],
        suggestionsUser: [],
        suggestionsRoles: []
    };

    static getDerivedStateFromProps(props, state) {
        const { info } = props;
        if (info !== state.info) {
            state.suggestionsUser =
                info !== undefined && info.security !== undefined
                    ? info.security.destinatarios
                        .filter((f) => f.type === 'user')
                        .sort((a, b) => a.name > b.name ? 1 : -1)
                        .map((s) => {
                            return {
                                label: s.name,
                                value: s.id,
                            }
                        }, [])
                    : [];
            state.suggestionsRoles =
                info !== undefined && info.security !== undefined
                    ? info.security.destinatarios
                        .filter((f) => f.type === 'rol')
                        .sort((a, b) => a.name > b.name ? 1 : -1)
                        .map((s) => {
                            return {
                                label: s.name,
                                value: s.id,
                            }
                        }, [])
                    : [];

            state.locals =
                info !== undefined && info.security && info.security.locals
                    ? info.security.locals.map((l) => {
                        return { value: l.id, label: l.path };
                    })
                    : undefined;

            state.info = info;
            return state;
        }
        return null;
    }

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleChangeRol = (value) => {
        this.setState({ selectedroles: value });
    }

    handleChangeUser = (value) => {
        this.setState({ selectedusers: value });
    }

    handleChangeLocal = (value) => {
        this.setState({ selectedlocals: value });
    }

    handleUpdate = (name, values) => {
        this.setState({
            [name]: values,
        });
    };

    handleRemoveDate = (nombre) => (event) => {
        this.setState({ [nombre]: '' });
    };

    handleChecked = (event) => {
        this.setState({ [event.target.name]: event.target.checked });
    };

    render() {
        const {
            from,
            to,
            saved,
            pending,
            urgent,
            selectedroles,
            selectedlocals,
            selectedusers,
            suggestionsRoles,
            suggestionsUser,
            locals,
        } = this.state;
        const { intl } = this.props;
        return (
            <div className={'flex_full_column  overflow_y_scroll height100 communication_menu showbar'}>
                <div className="flex_auto_row padding_borders_flat align_center margin_top_18">
                    <div className="flex_full_row">
                        <CloseIcon
                            className="c_slate_grey hand"
                            onClick={this.props.onClose(false)}
                        />
                    </div>
                    <div
                        className="flex_auto_row align_center button-remove barlow_regular_small hand"
                        onClick={this.props.onClose(true, {
                            from: '',
                            to: '',
                            saved: false,
                            urgent: false,
                            pending: false,
                            selectedroles: undefined,
                            selectedlocals: undefined,
                            selectedusers: undefined
                        })}
                    >
                        <Delete className="c_lipstick hand" />
                        {intl.formatMessage({ id: 'communication_remove' })}
                    </div>
                    <div
                        className="margin_left_6 flex_auto_row align_center button-keep barlow_regular_small hand"
                        onClick={this.props.onClose(true, {
                            from: from,
                            to: to,
                            pending: pending,
                            saved: saved,
                            urgent: urgent,
                            selectedroles: selectedroles,
                            selectedlocals: selectedlocals,
                            selectedusers: selectedusers
                        })}
                    >
                        <TickIcon className="c_pea hand" />
                        {intl.formatMessage({ id: 'communication_apply' })}
                    </div>
                </div>
                <div className="flex_auto_row padding_borders_flat align_center">
                    <div className="flex_full_row">
                        <div className="flex_auto_row button-message barlow_regular_small c_disabled border_disabled">
                            {intl.formatMessage({ id: 'communication_saved' })}
                        </div>
                    </div>
                    <div className="flex_auto_column">
                        <Switch
                            name={'saved'}
                            checked={saved}
                            onChange={this.handleChecked}
                            value="saved"
                            color="primary"
                        />
                    </div>
                </div>

                <div className="flex_auto_row padding_borders_flat align_center">
                    <div className="flex_full_row">
                        <div className="flex_auto_row button-message barlow_regular_small c_lipstick border_lipstick">
                            {intl.formatMessage({ id: 'communication_text_urgent' })}
                        </div>
                    </div>
                    <div className="flex_auto_column">
                        <Switch
                            name={'urgent'}
                            checked={urgent}
                            onChange={this.handleChecked}
                            value="urgent"
                            color="primary"
                        />
                    </div>
                </div>
                <div className="flex_auto_row padding_borders_flat align_center">
                    <div className="flex_full_row">
                        <div className="flex_auto_row button-message barlow_regular_small c_bluish border_bluish">
                            {intl.formatMessage({ id: 'communication_text_pending' })}
                        </div>
                    </div>
                    <div className="flex_auto_column">
                        <Switch
                            name={'pending'}
                            checked={pending}
                            onChange={this.handleChecked}
                            value="pending"
                            color="primary"
                        />
                    </div>
                </div>
                <div className="flex_auto_column margin_top_18 padding_borders_flat align_center barlowcondensed_medium force_w_100">
                    <div className="flex_auto_row width100">
                        <PermIdentity className="c_disabled margin_right_6" />
                        <div className="flex_auto_row button-message barlowcondensed_medium c_state">
                            {intl.formatMessage({ id: 'communication_user_text' })}
                        </div>
                    </div>
                    <SelectInput
                        defaultValue={selectedusers}
                        //placeHolder={intl.formatMessage({ id: 'form_field_user_roles_hierarchies' })}
                        options={suggestionsUser}
                        onChange={this.handleChangeUser}
                    />
                </div>
                <div className="flex_auto_column margin_top_18 padding_borders_flat align_center barlowcondensed_medium force_w_100">
                    <div className="flex_auto_row width100">
                        <PermIdentity className="c_disabled margin_right_6" />
                        <div className="flex_auto_row button-message barlowcondensed_medium c_state">
                            {intl.formatMessage({ id: 'communication_rol_text' })}
                        </div>
                    </div>
                    <SelectInput
                        defaultValue={selectedroles}
                        //placeHolder={intl.formatMessage({ id: 'form_field_user_roles_hierarchies' })}
                        options={suggestionsRoles}
                        onChange={this.handleChangeRol}
                    />
                </div>

                <div className="flex_auto_column margin_top_18 padding_borders_flat align_center barlowcondensed_medium force_w_100">
                    <div className="flex_auto_row width100">
                        <Home className="c_disabled margin_right_6" />
                        <div className="flex_auto_row button-message barlowcondensed_medium c_state">
                            {intl.formatMessage({ id: 'communication_area' })}
                        </div>
                    </div>
                    <SelectInput
                        defaultValue={selectedlocals}
                        //placeHolder={intl.formatMessage({ id: 'communication_area_text' })}
                        options={locals}
                        onChange={this.handleChangeLocal}
                    />
                </div>
                <div className="flex_auto_row margin_top_18 padding_borders_flat align_center barlowcondensed_medium">
                    <Timer className="c_disabled margin_right_6" />
                    {intl.formatMessage({ id: 'communication_sent_date' })}
                </div>
                <div className="flex_auto_row padding_borders_flat align_center margin_top_8">
                    <TextField
                        fullWidth
                        name={'from'}
                        id={'from-date'}
                        label={intl.formatMessage({ id: 'communication_date_from' })}
                        type="datetime-local"
                        value={from ? from : ''}
                        onChange={this.handleChange}
                        className="barlow_regular_small"
                        InputLabelProps={{ shrink: true }}
                    />
                    <Close className="c_lipstick hand" onClick={this.handleRemoveDate('from')} />
                </div>
                <div className="flex_auto_row padding_borders_flat align_center margin_top_8 ">
                    <TextField
                        fullWidth
                        name={'to'}
                        id={'to-date'}
                        label={intl.formatMessage({ id: 'communication_date_to' })}
                        type="datetime-local"
                        value={to ? to : ''}
                        onChange={this.handleChange}
                        InputLabelProps={{ shrink: true }}
                    />
                    <Close className="c_lipstick hand" onClick={this.handleRemoveDate('to')} />
                </div>
            </div>
        );
    }
}

export default Filter;



// WEBPACK FOOTER //
// ./src/components/complex/communications/Filter.js